import React from 'react';
import { ProjectShareForm } from './project-share-form';
import { FormattedMessage } from 'react-intl';

export class ProjectModalSuccess extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { newProject = {}, closeModal } = this.props;
    return (
      <div className="project-success-body">
        <div className="text-center">
          <h3>
            <FormattedMessage
              id="boards.project_modal_success.who_else"
              defaultMessage="Who else is planning?"
            />
          </h3>
          <div>
            <div className="text-gray-dark inline-block">
              <FormattedMessage
                id="boards.project_modal_success.invite_others"
                defaultMessage="Invite others to help you choose the perfect space"
              />
            </div>
          </div>
        </div>
        <hr />
        <ProjectShareForm
          {...this.props}
          emailOrigin={'create board flow'}
          sharedProject={newProject}
        />
        <div className="text-center cancel-btn">
          <a onClick={closeModal}>
            <FormattedMessage
              id="boards.project_modal_success.not_now"
              defaultMessage="Not Now"
            />
          </a>
        </div>
      </div>
    );
  }
}
